// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3YDly","card":"Cards_card__1Bbxi","Infected":"Cards_Infected__3PDa8","Recovered":"Cards_Recovered__1UpMA","Deaths":"Cards_Deaths__pijhE"};